var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82502 5.5H8.50002V1.33333C8.50002 0.875 8.12502 0.5 7.66669 0.5H4.33335C3.87502 0.5 3.50002 0.875 3.50002 1.33333V5.5H2.17502C1.43335 5.5 1.05835 6.4 1.58335 6.925L5.40835 10.75C5.73335 11.075 6.25835 11.075 6.58335 10.75L10.4084 6.925C10.9334 6.4 10.5667 5.5 9.82502 5.5ZM0.166687 13.8333C0.166687 14.2917 0.541687 14.6667 1.00002 14.6667H11C11.4584 14.6667 11.8334 14.2917 11.8334 13.8333C11.8334 13.375 11.4584 13 11 13H1.00002C0.541687 13 0.166687 13.375 0.166687 13.8333Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillDownArrow);
export default __webpack_public_path__ + "static/media/fill-down-arrow.4a6616c40745d57ea203d7eded0ad25a.svg";
export { ForwardRef as ReactComponent };